import React, { useEffect, useMemo, useState } from "react";
import { colors, fonts, glyphs } from "../../Styles";
import { ButtonTypes, CreateNewFieldStyle, CreateNewFieldType, NewFieldStyles, NewFieldTypes } from "../../Definitions";
import { useTranslation } from "react-i18next";
import { Button, PrimaryPopover } from "..";

interface feedCorrectionPopoverProps {
  header?: string
  defaultValue?: number
  operationView?: boolean
  onChange?: (value: number) => void
  fieldOverrides?: {
    fieldHeight?: string
    fieldStyle?: NewFieldStyles,
    fieldType?: NewFieldTypes,
    fieldWidth?: string
  }
}

export default function FeedCorrectionPopover({ header, defaultValue, operationView=false, onChange, fieldOverrides }:feedCorrectionPopoverProps) {
  const {t} = useTranslation()
  const [feedCorrection, setFeedCorrection] = useState<number | undefined>(defaultValue);

  useEffect(() => {
    if (onChange && feedCorrection !== undefined) {
      onChange(feedCorrection);
    }
  }, [feedCorrection]);

  const decrease = () => {
    setFeedCorrection((feedCorrection ?? 0) -1);
  };

  const increase = () => {
    setFeedCorrection((feedCorrection?? 0) +1);
  };

  const reset = () => {
    setFeedCorrection(0);
  };

  const { primaryColor, fontColor } = useMemo(() => {
    var _Style = CreateNewFieldStyle(fieldOverrides?.fieldStyle)
    return _Style
  }, [fieldOverrides?.fieldStyle])

  // FieldType
  const { height, containerPaddingTop, containerPaddingRight, containerPaddingBottom, containerPaddingLeft, indicatorPadding, indicatorSeparatorDisplay, dropdownIndicator, placeholderDisplay } = useMemo(() => {
    var _Style = CreateNewFieldType(fieldOverrides?.fieldType)
    return _Style
  }, [fieldOverrides?.fieldType])

  const feedCorrectionPopoverStyle = {display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer"}

  const _height = fieldOverrides&&fieldOverrides.fieldHeight ? fieldOverrides.fieldHeight : height

  return ( 
    <div style={{width: "100%", maxWidth: "280px"}}>
      {header && <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyPrimary, padding: "0px 0px 2px 10px"}}>{header}</p>}
      <PrimaryPopover 
        content={feedCorrection ? feedCorrection+"%" : "0%"} 
        createPopoverPortal={operationView ? true : false}
        overrides={{
          contentContainer: {
            ...fonts.paragraph,
            ...fonts.fontSize4,
            color: fontColor,
            height: _height,
            backgroundColor: primaryColor,
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            padding: `${containerPaddingTop}px ${containerPaddingRight}px ${containerPaddingBottom}px ${containerPaddingLeft}px`,
            overflow: "hidden",
            cursor: "pointer",
            width: "100%",
            maxWidth: "280px",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis"
          }
        }}
        popoverHeader={t("feed.feedCorrection.feedCorrection", {defaultValue: "Feed Correction"})} 
        popoverContent={
          <div style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gridTemplateRows: "repeat(2, 40px)"}}>
            <div style={{gridArea: "1/1/2/2", ...feedCorrectionPopoverStyle, borderRight: "1px solid "+colors.greyDarkSecondary}}>
              <Button content={""} buttonType={ButtonTypes.textButton} startEnhancer={<glyphs.Minus/>} onClick={decrease} overrides={{baseButton: {width: "100%"}}}/> 
            </div>
            <div style={{gridArea: "1/2/2/3", ...feedCorrectionPopoverStyle, borderLeft: "1px solid "+colors.greyDarkSecondary}}>
              <Button content={""} buttonType={ButtonTypes.textButton} startEnhancer={<glyphs.Add/>} onClick={increase} overrides={{baseButton: {width: "100%"}}}/> 
            </div>
            <div style={{gridArea: "2/1/3/3", ...feedCorrectionPopoverStyle, borderTop: "2px solid "+colors.greyDarkSecondary, color: colors.greyLightTertiary, ...fonts.fontSize3, ...fonts.header}}>
            <Button content={t("feed.feedCorrection.reset", {defaultValue: "reset"})} buttonType={ButtonTypes.textButton} onClick={reset} overrides={{baseButton: {width: "100%"}}}/> 
            </div>
          </div>
        }
      /> 
    </div> 
  )
}